import { Beech } from './beech';

export class Util {
	private beech: Beech;

	public constructor(beech: Beech) {
		logg.log('util >> init');
		this.beech = beech;
	}

	public createRandomString = (length: number): string => {
		let text = '';
		let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

		for (let i = 0; i < length; i++) {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}

		return text;
	};
}
